// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2llQ2","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1yyfa"};